import { useTranslation } from "react-i18next";
import { SupportRequests } from "@/partner/features/supportRequests";
import { Meta } from "@/shared/components";

export function AudienceRequestsPage() {
  const { t } = useTranslation();

  return (
    <>
      <Meta title={t("requests.pageTitle")} pageType="Partner" />
      <SupportRequests />
    </>
  );
}
